import { ModalProps } from 'almanac-ui/Modal/Types'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { ConnectableAccount } from 'api/clients/IntegrationAuthsClient'

export enum SetupState {
  AccountOverview,
  AdAccountSelection,
  FacebookPageSelection,
  InstagramAccountSelection,
}

export interface MetaAdsAccountSetupModalProps extends Pick<ModalProps, 'onPressOutside'> {
  connectableAccounts: ConnectableAccount[]
  metadata: any
  onCancel: () => void
  handleSubmit: (accounts: ConnectableAccount[]) => void
}

export type MetaAdsAdAccount = {
  provider_id: string
  provider: ExternalIntegrationEnum.MetaAds
  account_type: 'ad_account'
  name: string
  picture: string | null
  additional_data: {
    account_status: number
    currency: string
    timezone_name: string
    amount_spent: string
    business_name: string
    business_id: string
  }
}

export type MetaAdsFacebookPage = {
  provider_id: string
  provider: ExternalIntegrationEnum.Facebook
  account_type: 'page'
  name: string
  picture: string
  additional_data: {
    fan_count: number
    category: string
    verification_status: string
  }
}

export type MetaAdsInstagramAccount = {
  provider_id: string
  provider: ExternalIntegrationEnum.Instagram
  account_type: 'profile'
  name: string
  picture: string
  additional_data: {
    username: string
    followers_count: number
  }
}

export type MetaAdsAccounts = {
  adAccounts: MetaAdsAdAccount[]
  facebookPages: MetaAdsFacebookPage[]
  instagramAccounts: MetaAdsInstagramAccount[]
}

export type SetupConfiguration = {
  adAccountId?: string
  facebookPageId?: string
  instagramAccountId?: string
}
